import { getCookie } from '@picsart/rc/cookie';
import { defaultLanguage, languageCookieKey, languagesCodesListFull } from 'constants/languages';
import { useLocation } from 'react-router-dom';
import trim from 'utils/trim';

function usePageLanguage() {
  const { pathname } = useLocation();

  const getLanguage = () => {
    const cookieLanguage = getCookie(languageCookieKey);

    const routerLanguage = pathname && trim(pathname, '/')?.split('/')?.[0];

    // checking router param is language or page slug
    const validRouterLanguage = languagesCodesListFull.find(l => l === routerLanguage);
    // checking cookie language is valid
    const validCookieLanguage = languagesCodesListFull.find(l => l === cookieLanguage);

    // getting language by priority
    // 1. Route language
    // 2. Cookie language
    // 3. default language (en)
    const realLanguage = validRouterLanguage ?? validCookieLanguage ?? defaultLanguage;
    return realLanguage;
  };
  return {
    language: getLanguage(),
  };
}

export default usePageLanguage;
